import {Component, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import {DatePipe} from '@angular/common';
declare let $: any;
declare let window: any;

@Component({
  selector: 'admin-console',
  templateUrl: './adminConsole.component.html',
  styleUrls: ['./adminConsole.component.css']
})
export class AdminConsoleComponent implements OnInit {
  selTab = 0;
  cardsFound = [];
  cardBackHeight = 0;
  selectedCardBack: any = {};
  denialReasons = [
    {
      id: 1,
      reason: "The image used in the card is copyrighted.",
      selected: false
    },
    {
      id: 2,
      reason: "The card uses inappropriate language.",
      selected: false
    },
    {
      id: 3,
      reason: "The card depicts violence.",
      selected: false
    },
    {
      id: 4,
      reason: "The color scheme of the card isn't appealing.",
      selected: false
    },
    {
      id: 5,
      reason: "I'm denying this card for no reason other than wanting to use this button.",
      selected: false
    },
    {
      id: 6,
      reason: "The card back is meaningless as an advertisement.",
      selected: false
    },
    {
      id: 7,
      reason: "The card back is inappropriate for persons of all ages.",
      selected: false
    }
  ];
  denyMessage = "";
  prelimApprov = false;
  approved = false;
  advertisement = false;
  rejected = false;
  paid = false;
  impressions = -1;
  appBy = "";
  email = "";
  passedInit = false;

  userList = [];
  selectedUser = null;
  searchUsersText = "";
  saveUserList = [];

  constructor(private app: AppService, private dp: DatePipe) {

  }

  ngOnInit() {
    this.app.broadcaster.subscribe((value) => {
      this.broadCastHandle(value);
    });
    if (this.app.appMode === 3) {
      this.loadAdminConsole();

      this.loadUserList();
    }
  }

  getEditBoxHeight() {
    let width = window.innerWidth < 1400 ? "100%" : "100%";
    let height = 800;
    return {'height': height + 'px', 'width': width};
  }

  getDisplayCardStyle() {
    let el = document.getElementById("cardDisplayArea");
    let width = el.offsetWidth;
    let height = 700;
    let potentialWidth = Math.ceil(700 / 1.6);
    let top = 50;
    let left = 0;
    if (width < potentialWidth) {
      width = width - 50;
      height = Math.ceil(width * 1.6);
      top = Math.ceil((800 - height) / 2);
      left = 25;
    } else {
      left = Math.ceil((width - potentialWidth) / 2);
      width = potentialWidth;
    }
    return {position: 'absolute', top: top + 'px', left: left + 'px', height: height + 'px', width: width + 'px'};
  }

  cardStatusClass() {
    if (this.selectedCardBack.preliminary_approved && this.selectedCardBack.approved) {
      return 'approvedCard';
    }
    return this.selectedCardBack.rejected ? 'cardRejected' : 'pendingApproval';
  }

  loadAdminConsole() {
    // this.app.getAdminConsoleCards().subscribe((data: any) => {
    //   console.log("Admin console cards found: ", data);
    //   this.cardsFound = data;
    // }, (error) => {
    //   console.log("Error getting admin console cards: ", error);
    // });
  }

  searchCards() {
    console.log("UserID: " + this.app.user.id);
    console.log("Search cards info: ", this.approved, this.appBy, this.advertisement, this.paid, this.rejected,
      false, this.impressions, this.email);
    console.log("SessionID: ", this.app.getSessionID());
    this.selectedCardBack = {};
    this.app.searchCards(this.app.user.id, this.prelimApprov, this.approved, this.appBy, true, true, this.rejected,
      this.app.user.tier !== 100, this.impressions, this.email).subscribe((data: any) => {
      console.log("Search data: ", data);
      this.cardsFound = data;
      this.checkFilters();
      console.log("Cards found length: ", this.cardsFound.length);
      if (this.cardsFound.length < 1) {
        console.log("Resetting init");
        this.passedInit = false;
        this.cardBackHeight = 0;
      }
      if (!this.passedInit && this.cardsFound.length > 0) {
        setTimeout(() => {
          this.passedInit = true;
        }, 2000);
      }
    }, (error) => {
      console.log("Search error: ", error);
    });
  }

  checkFilters() {
    this.cardsFound = this.cardsFound.filter((c) => {
      console.log("Checking card: ", c);
      if (this.app.user.tier !== 100) {
        return !c.preliminary_approved && !c.approved && !c.rejected;
      } else {
        console.log("Result: ", c.preliminary_approved && !c.rejected && !c.approved);
        if (this.prelimApprov) {
          return c.preliminary_approved && !c.rejected && !c.approved;
        } else {
          return true;
        }
      }
    });
    console.log("New list: ", this.cardsFound);
  }

  processCard(result) {
    if (this.app.user.tier === 100) {
      if (!this.selectedCardBack.preliminary_approved) {
        alert("Unable to approve: This card hasn't been gone through preliminary approval yet.");
        return;
      }
    }
    if (result) {
      this.app.processCard(this.selectedCardBack.id, this.app.user.id, true, "").subscribe((data) => {
        console.log("Card processed / Approved: ", data);
        this.clearCardInfo();
      }, (error) => {
        if (error.status === 417) {
          console.log("417 code");
          alert("Unable to approve card: This card has already been processed.");
          this.selectedCardBack = {};
          this.searchCards();
        }
        console.log("Error processing card: ", error);
      });
    } else {
      if (!this.denialReasons.some((i) => {
        return i.selected;
      })
      ) {
        alert("Please select a reason for denying this card.");
      } else {
        let deny = "";
        this.denialReasons.forEach((d) => {
          if (d.selected) {
            deny = deny + d.reason;
          }
          d.selected = false;
        });
        this.app.processCard(this.selectedCardBack.id, this.app.user.id, false, deny).subscribe((data) => {
          console.log("Card processed / Denied: ", data);
          this.clearCardInfo();
        }, (error) => {
          console.log("Error processing card: ", error);
        });
      }
    }
  }

  checkIfCardAnalyzable() {
    if (this.app.user.tier === 100) {
      return this.selectedCardBack.preliminary_approved && !(this.selectedCardBack.approved || this.selectedCardBack.rejected);
    } else if (this.app.user.tier === 99) {
      return !this.selectedCardBack.preliminary_approved && !(this.checkIfBeenDenied());
    }
    return false;
  }

  checkIfBeenDenied() {
    return this.selectedCardBack.rejected;
  }

  getDenialText() {
    return "Edit this denial";
  }


  clearCardInfo() {
    this.denyMessage = "";
    this.removeCardFromList(this.selectedCardBack);
    this.selectedCardBack = {};
    this.selTab = 0;
  }

  removeCardFromList(card) {
    this.cardsFound = this.cardsFound.filter((c) => {
      return c.id !== card.id;
    });
  }

  cardBackClicked(card) {
    console.log("Card clicked: ", card);
    this.denyMessage = "";
    this.selectedCardBack = card;
    if (!this.selectedCardBack.historyRan) {
      this.selectedCardBack.historyRan = true;
      this.selectedCardBack.history.forEach((h) => {
        let d = new Date(h.datetime);
        h.date = this.dp.transform(d, 'MM/dd/yyyy');
        h.time = this.dp.transform(d, 'HH:mm:ss');
        h.actionText = h.action === 1 ? (!h.final ? 'Prelim Rejected' : 'Final Rejected') : (h.action === 2 ? (!h.final ? 'Prelim Approved' : 'Final Approved') : 'Cleared');
      });
    }
  }

  getCardBackDisplayStyle(cardBack) {
    let width = 0;
    let usedHeight = 0;
    if (!this.passedInit) {
      let el = document.getElementById("cardBack" + cardBack.id);
      if (!el) {
        return {};
      }
      let height = el.clientHeight;
      width = el.clientWidth;

      cardBack.width = width - 30;
      cardBack.height = Math.ceil((width - 30) * 1.6);
      cardBack.elHeight = height;
      this.cardBackHeight = Math.ceil((width - 10) * 1.6);
      let margin = 10;
      if (cardBack.elHeight) {
        margin = Math.ceil((cardBack.elHeight - cardBack.height) / 2);
      }
      usedHeight = Math.ceil((width - 10) * 1.6);
    } else {
      usedHeight = this.cardBackHeight;
    }

    return cardBack.id === this.selectedCardBack.id ?
      {'border': '1px solid green', 'box-shadow' : '2px 2px 25px 8px #ffd11a', 'margin' : '10px', 'height': usedHeight + 'px'} :
      {'border': '1px solid black', 'margin' : '10px', 'height': usedHeight + 'px'};
  }

  broadCastHandle(value: Object): void {
    switch(value['event']) {
      case 'loadAdminConsole':
        this.loadAdminConsole();
        break;
      default:
        break;
    }
  }

  getStatusText(card: any) {
    if (card.rejected) {
      return 'Rejected';
    }
    if (this.selectedCardBack.preliminary_approved && this.selectedCardBack.approved) {
      return 'Approved';
    } else {
      return 'Pending Approval';
    }
  }

  tabClicked(tab) {
    this.selTab = tab;
  }

  loadUserList() {
    this.app.getUserList().subscribe((data: any) => {
      console.log("User list data: ", data);
      this.saveUserList = data;
      this.userList = data;
    }, (error) => {
      console.log("User list error: ", error);
    });
  }

  userClicked(user) {
    console.log("User clicked: ", user);
    this.selectedUser = user;
  }

  changeUserTier(type) {
    switch(type) {
      case 0:
        this.runUserTypeChange(0);
        break;
      case 1:
        this.runUserTypeChange(99);
        break;
      case 2:
        this.runUserTypeChange(100);
        break;
      default:
        break;
    }
  }

  runUserTypeChange(tier) {
    this.app.changeAccountTier(this.selectedUser.id, tier).subscribe((data) => {
      console.log("User tier changed: ", data);
      this.selectedUser.tier = tier;
    }, (error) => {
      console.log("Changing user type error: ", error);
    });
  }

  searchUserTextChanged() {
    console.log("Seach text changed: ", this.searchUsersText);
    this.userList = this.saveUserList.filter((u) => {
      console.log("Email: ", u.email, this.searchUsersText, u.email.indexOf(this.searchUsersText) !== -1);
      return u.email.indexOf(this.searchUsersText) !== -1 || u.id === parseInt(this.searchUsersText) || u.tier === parseInt(this.searchUsersText);
    });
    console.log("New user list: ", this.userList);
  }
}
